import { render, staticRenderFns } from "./CloneAndEditAdmin.vue?vue&type=template&id=0640de62&scoped=true&"
import script from "./CloneAndEditAdmin.vue?vue&type=script&lang=js&"
export * from "./CloneAndEditAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CloneAndEditAdmin.vue?vue&type=style&index=0&id=0640de62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640de62",
  null
  
)

export default component.exports